import { ReactSVG } from "react-svg";

import { OFFICE_STATUS_OPTIONS } from "services/api/offices/consts";
import { OfficeRow } from "services/api/offices/types";
import { Badge } from "ui/components/Badge";
import { BadgeProps } from "ui/components/Badge/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

/** Status se sprema kao šifra (`active`), pa se ispisuje naziv iz istog popisa koji nudi obrazac. */
const statusText = (status: string | null): string =>
  OFFICE_STATUS_OPTIONS.find((option) => option.value === status)?.text ?? status ?? "";

const STATUS_VARIANT: Record<string, BadgeProps["variant"]> = {
  active: "success",
  inactive: "secondary",
  temporarily_closed: "warning",
};

/** Adresa u jednom retku; prazni dijelovi ne ostavljaju zareze za sobom. */
const formatAddress = (row: OfficeRow): string =>
  [row.primaryAddress?.line1, row.primaryAddress?.postalCode, row.primaryAddress?.city]
    .filter(Boolean)
    .join(", ");

export const TENANT_OFFICE_COLUMNS = (
  handleDeleteClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void
): Column[] => [
  {
    title: "Poslovnica",
    field: "name",
    type: ColumnTypes.custom,
    render: (row: OfficeRow) => (
      <div>
        <div className="text-md font-medium text-slate-600">{row.name}</div>

        {/* Šifra i interna oznaka su ono po čemu se poslovnice razlikuju kad se imena ponove. */}
        {(row.code || row.internalMark) && (
          <div className="text-xs text-slate-400 mt-0.5">
            {[row.code, row.internalMark].filter(Boolean).join(" · ")}
          </div>
        )}
      </div>
    ),
  },
  {
    title: "Adresa",
    field: "primaryAddress",
    type: ColumnTypes.custom,
    render: (row: OfficeRow) =>
      formatAddress(row) ? (
        <span className="text-sm text-slate-900">{formatAddress(row)}</span>
      ) : (
        <span className="text-sm text-slate-400">Bez adrese</span>
      ),
  },
  {
    title: "Kontakt",
    field: "primaryPhone",
    type: ColumnTypes.custom,
    render: (row: OfficeRow) => (
      <div className="text-sm text-slate-900">
        {row.primaryPhone?.phoneNumber && <div>{row.primaryPhone.phoneNumber}</div>}

        {row.primaryEmail?.emailAddress && (
          <div className="text-xs text-slate-500">{row.primaryEmail.emailAddress}</div>
        )}

        {!row.primaryPhone?.phoneNumber && !row.primaryEmail?.emailAddress && (
          <span className="text-slate-400">Bez kontakta</span>
        )}
      </div>
    ),
  },
  {
    title: "Status",
    field: "status",
    type: ColumnTypes.custom,
    render: (row: OfficeRow) =>
      row.status ? (
        <Badge
          text={statusText(row.status)}
          variant={STATUS_VARIANT[row.status] ?? "secondary"}
          height="small"
        />
      ) : (
        <></>
      ),
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OfficeRow) => (
      <div
        onClick={(e) => handleDeleteClick(e, row.id ?? "")}
        className="flex justify-end items-center h-[30px] cursor-pointer"
      >
        <ReactSVG src="/media/icons/trash.svg" className="w-4 h-4 stroke-[#bd0000]" />
      </div>
    ),
  },
];
